import classnames from 'classnames';

import { SettingsPageHeader } from './components/settings-page-header/settings-page-header';
import style from './settings-page.module.less';

import type { SettingsPageHeaderMessages } from './components/settings-page-header/settings-page-header';
import type React from 'react';

type SettingsPageWrapperProps = {
  children: React.ReactNode;
  className?: string;
  messages: SettingsPageHeaderMessages;
  descriptionContent?: React.ReactNode;
  isTabbed?: boolean;
};

const SettingsPageWrapper = ({ children, className, messages, descriptionContent = null, isTabbed = false }: SettingsPageWrapperProps) => {
  return (
    <div
      className={classnames(
        {
          [style['tabbed-content']]: isTabbed,
          [style.content]: !isTabbed,
        },
        className,
      )}
    >
      <SettingsPageHeader descriptionContent={descriptionContent} isTabbed={isTabbed} messages={messages} />
      {children}
    </div>
  );
};

export default SettingsPageWrapper;
